
export default function FeaturesSection() {
  const features = [
    {
      id: 'send-receive',
      icon: 'ri-send-plane-line',
      title: 'Send & Receive Crypto',
      description: 'Transfer crypto to anyone, anywhere in the world with just a few taps.',
    },
    {
      id: 'multi-asset',
      icon: 'ri-stack-line',
      title: 'Multi-Asset Support',
      description: 'Manage Bitcoin, Ethereum, and dozens of popular tokens in one place.',
    },
    {
      id: 'portfolio',
      icon: 'ri-pie-chart-line',
      title: 'Portfolio View',
      description: 'Track your holdings and see your portfolio performance at a glance.',
    },
    {
      id: 'qr-payments',
      icon: 'ri-qr-code-line',
      title: 'QR Payments',
      description: 'Scan or share QR codes for quick and easy transactions.',
    },
    {
      id: 'address-book',
      icon: 'ri-contacts-book-line',
      title: 'Address Book',
      description: 'Save frequently used addresses for faster, error-free transfers.',
    },
    {
      id: 'network-fees',
      icon: 'ri-gas-station-line',
      title: 'Clear Network Fees',
      description: 'See exactly what you\'ll pay before confirming any transaction.',
    },
  ];

  return (
    <section id="features" className="py-16 lg:py-24 bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-12 lg:mb-16">
          <h2 className="text-3xl sm:text-4xl font-bold text-gray-900 mb-4">
            Everything you expect in a modern wallet
          </h2>
          <p className="text-lg text-gray-600 max-w-2xl mx-auto">
            Powerful features wrapped in a simple, intuitive interface.
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-6 lg:gap-8">
          {features.map((feature) => (
            <div
              key={feature.id}
              className="bg-white rounded-2xl p-6 lg:p-8 hover:shadow-lg transition-shadow cursor-pointer group border border-gray-100"
            >
              <div className="w-12 h-12 bg-[#00D0A3]/10 rounded-xl flex items-center justify-center mb-5 group-hover:bg-[#00D0A3]/20 transition-colors">
                <i className={`${feature.icon} text-xl text-[#00D0A3]`}></i>
              </div>
              <h3 className="text-lg font-semibold text-gray-900 mb-2">{feature.title}</h3>
              <p className="text-gray-600 text-sm leading-relaxed">{feature.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
